import { useRouteError } from 'react-router-dom'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import WarningAmber from '@mui/icons-material/WarningAmber'
import { logger } from '$utils'

type FullPageErrorProps = {
  marginLeft?: number | string
  reason?: string
}

/**
 * Simple error component that is intended for display in the main content
 * section of the app when an error occurs preventing it being rendered.
 * @returns
 */
export default function FullPageError({
  marginLeft = 0,
  reason,
}: FullPageErrorProps) {
  const error = useRouteError()

  if (reason) {
    logger.info('Unable to render component due to %o', reason)
  } else {
    logger.error('Unexpected React render error %o', error)
  }

  return (
    <Box
      marginLeft={marginLeft}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        // 121px here is the sum of the the fixed Angular topbar height, bottom border, and bottom margin
        height: 'calc(100vh - 121px)',
      }}
    >
      <Grid container sx={{ marginTop: '-60px' }}>
        <Grid item xs={12}>
          <WarningAmber sx={{ fontSize: '92px' }} color="disabled" />
        </Grid>
        <Grid item xs={12} justifyContent="center" alignItems="center">
          <Typography variant="subtitle1">
            Sorry something unexpected has happened and we can&apos;t load the
            page you were trying to see.
          </Typography>
          <Typography variant="body1">
            If this keeps happening please contact our support team.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
